import React, { FC, useState } from 'react'
import { Column, Row } from 'react-table'
import Table from '../../components/Table';
import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { LocationOverviewData } from '../../api/mobilbase/models';
import * as mobilbase from '../../api/mobilbase';
import { RouteLocationProps } from '../../routes/mobilbase';
import APIRequest from '../../components/helpers/APIRequest';
import AlignedCell from '../../components/layout//AlignedCell';
import AlignedHeader from '../../components/layout/AlignedHeader';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  grid: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

interface Props {
  navFunc: ((historyState: RouteLocationProps) => void)
}

const LocationOverview: FC<Props> = ({ navFunc }) => {
  const classes = useStyles();
  const [data, setData] = useState<LocationOverviewData[]>([]);
  const [isPending, setIsPending] = useState(false);
  const [run, setRun] = useState(true);

  const handleChange = (element: LocationOverviewData) => {
    navFunc(new RouteLocationProps(1, element.id, element.name));
  };

  const columns: Column<LocationOverviewData>[] = React.useMemo(
    () => [
      { Header: 'Pladsnavn', id: "0", accessor: 'name'},
      { Header:()=><AlignedHeader value='Ok' justify='flex-end' alignT='right'/> , id: "1", accessor: 'okay', Cell: ({ value }: { value: string }) => <AlignedCell value={value} justify='right' /> },
      { Header:()=><AlignedHeader value='Fejl' justify='flex-end' alignT='right'/> , id: "2", accessor: 'error', Cell: ({ value }: { value: string }) => <AlignedCell value={value} justify='right' /> },
      { Header:()=><AlignedHeader value='Offline' justify='flex-end' alignT='right'/> , id: "3", accessor: 'offline', Cell: ({ value }: { value: string }) => <AlignedCell value={value} /> },
      { Header:()=><AlignedHeader value='Max. mønt' justify='flex-end' alignT='right'/> , id: "4", accessor: 'maxCoin', Cell: ({ value }: { value: string }) => <AlignedCell value={value} /> },
      { Header:()=><AlignedHeader value='Min. printtæller' justify='flex-end' alignT='right'/> , id: "5", accessor: 'minPrinterCounte', Cell: ({ value }: { value: string }) => <AlignedCell value={value} /> },
      { Header: 'Opdateret', id: "6", accessor: 'updated',
        sortType: (rowA: Row<LocationOverviewData>, rowB: Row<LocationOverviewData>) => {
          const a = rowA.values[6].split(/-|:| /); // the sorting is done on ID, which is why its "6" and not "Updated"
          const b = rowB.values[6].split(/-|:| /);
          return ((a[2] + a[1] + a[0] + a[3] + a[4] + a[5]) < (b[2] + b[1] + b[0] + b[3] + b[4] + b[5])) ? -1 : 1
        }
      },
    ],
    []
  );

  function customCellStyle <T extends object>(columns: Column<T>[], index: number, value: any) {
    return {
      background: (columns[index].accessor?.toString() === "error" && value > 0) ? "rgba(255, 0, 0, 0.3)" : ""
    }
  }

  const RequestData = () => {
    return (
      <APIRequest<LocationOverviewData[]> 
          run={run} 
          setRun={setRun}
          pending={isPending}
          setIsPending={setIsPending} 
          req={mobilbase.getLocationOverview}
          setData={setData}
      />
    );
  }
    return (
      <Container maxWidth={false}>
        <RequestData />
          <div className={classes.paper}>
              <Typography component="h1" variant="h5">
                Pladsoversigt
              </Typography>
          <div className={classes.grid}>
          <Grid container spacing={2}>
              <Grid item xs={12}>
                <Table<LocationOverviewData> 
                  columns={columns} 
                  data={mapLocationOverviewData(data)} 
                  initialState={{pageSize: 150}} 
                  clickEvent={handleChange} 
                  update={() => {setRun(true)}} 
                  pending={isPending} 
                  text={""}
                  customCellStyle={customCellStyle} 
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    );
}

export default LocationOverview;

export const mapLocationOverviewData = (data: LocationOverviewData[] | undefined) => {
  if (!data) {
    return [];
  }

  return data.map(d => {
    var l = {...d};
    l.maxCoin = (l.maxCoin === -1) ? "-" : l.maxCoin;
    l.minPrinterCounte = (l.minPrinterCounte === -1) ? "-" : l.minPrinterCounte;
    return l;
  });
}